
      // Coffee Visitor-ID / Product-Usage pixel (dogfood).
      // Vite doesn't substitute `%VITE_*%` placeholders in index.html
      // for this project (no envCompatible plugin configured), so we
      // read the env values via `import.meta.env` in a module script.
      // `type="module"` is required for that syntax. Vite inlines the
      // referenced env vars at build time and the rest of the IIFE
      // remains tree-shakable.
      //
      // Loading via a dynamically-created <script> keeps the pixel out
      // of the critical render path and lets us gate on the env flag
      // without a redeploy. Autocapture is enabled later from
      // src/lib/posthog.ts via `window.coffee.init({ autocapture: true })`
      // (not via the data-coffee-autocapture attribute here), so the
      // toggle lives next to the rest of the analytics init code and
      // can be flipped without editing index.html.
      //
      // The pixel base URL follows VITE_VISITOR_ID_API_URL — the same
      // env var the VID API client uses — so each coffeecrm environment
      // (preview / stg / prd) loads the pixel from its matching VID env
      // (visitor-id.{stg,prd}.coffee.work). Prd fallback is for safety
      // when the env var isn't set.
      try {
        const enabled = import.meta.env.VITE_COFFEE_USAGE_ENABLED === 'true';
        const id = import.meta.env.VITE_COFFEE_USAGE_WEBHOOK_ID || '';
        const base = import.meta.env.VITE_VISITOR_ID_API_URL || 'https://visitor-id.prd.coffee.work';
        if (enabled && id) {
          const s = document.createElement('script');
          // Load /pixel-v2 — the new bundle with window.coffee SDK + opt-in
          // autocapture. Existing customers continue loading /pixel from
          // their own installs unchanged; this dogfood path uses the new
          // bundle. See visitor-id-service#29 for the endpoint split.
          //
          // `data-coffee-autocapture="true"` is read by the pixel itself
          // on init (see PIXEL_V2_JS in visitor-id-service/api/src/application.ts
          // — final lines of the IIFE). Using the attribute path avoids the
          // race where src/lib/posthog.ts's initPostHog() would call
          // `window.coffee?.init({autocapture:true})` before the async
          // pixel had finished loading, silently no-op'ing the optional
          // chain and leaving autocapture disabled.
          s.setAttribute('data-coffee-autocapture', 'true');
          s.src = base.replace(/\/$/, '') + '/pixel-v2?id=' + encodeURIComponent(id);
          s.async = true;
          document.head.appendChild(s);
        }
      } catch (e) { /* ignore */ }
    